import { useContext } from 'react';
import { E as ErrorIdContext } from './ErrorIdProvider-D8z7hbHY.js';

/**
 * DO NOT USE OUTSIDE OF STORM UI
 *
 * Returns a function to throw an error
 * decorated with a searchable StormUI keyword
 *
 * If the ErrorIdProvider context is
 * available, the error message will
 * be prepended with the given error ID
 */
const useStormError = () => {
  var _useContext;
  const id = (_useContext = useContext(ErrorIdContext)) === null || _useContext === void 0 ? void 0 : _useContext.id;
  const throwStormError = (feature, message) => {
    let errorMsg = `storm-ui:${feature} ${message}`;
    if (id) {
      errorMsg = `${id}:${errorMsg}`;
    }
    throw new Error(errorMsg);
  };
  return {
    throwStormError
  };
};

export { useStormError as u };
//# sourceMappingURL=useStormError-CitRd0-Z.js.map
